module.exports = __webpack_public_path__ + "img/data_moun_sm.8df45540.png";